// extracted by mini-css-extract-plugin
export var content = "_49-3";
export var list = "_49-4";
export var settingsContent = "_49-7";
export var settingsPanel = "_49-8";
export var state = "_49-6";
export var triggerBadge = "_49-2";
export var triggerButton = "_49-1";
export var triggerShell = "_49-0";
export var unreadDot = "_49-5";